import { __awaiter, __decorate, __extends, __generator } from "tslib";
import AbpBase from '@/lib/AbpBase';
import { Component, Prop } from 'vue-property-decorator';
import { RoleServiceProxy } from '@/lib/service-proxy/service-proxies';
var SelectRoleModal = /** @class */ (function (_super) {
    __extends(SelectRoleModal, _super);
    function SelectRoleModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.roles = [];
        _this.totalCount = 0;
        _this.currentPage = 1;
        _this.roleService = new RoleServiceProxy();
        return _this;
    }
    Object.defineProperty(SelectRoleModal.prototype, "roleColumns", {
        get: function () {
            var vm = this;
            return [
                { key: 'id', title: 'Id', width: 80, align: 'center' },
                { key: 'displayName', title: '角色名称' },
                {
                    key: 'actions',
                    title: '操作',
                    width: 100,
                    align: 'center',
                    render: function (h, params) {
                        return h('Button', {
                            props: { size: 'small', type: 'primary' },
                            on: {
                                click: function () {
                                    if (vm.onSelected !== undefined) {
                                        vm.onSelected(params.row);
                                    }
                                }
                            }
                        }, '选择');
                    }
                }
            ];
        },
        enumerable: true,
        configurable: true
    });
    ;
    SelectRoleModal.prototype.mounted = function () {
        this.getRoles();
    };
    SelectRoleModal.prototype.getRoles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var skip, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        skip = (this.currentPage - 1) * 10;
                        return [4 /*yield*/, this.roleService.getRoles()];
                    case 1:
                        result = _a.sent();
                        this.loading = false;
                        this.roles = result.items;
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    SelectRoleModal.prototype.pageChange = function () {
        this.getRoles();
    };
    __decorate([
        Prop({ type: Function })
    ], SelectRoleModal.prototype, "onSelected", void 0);
    SelectRoleModal = __decorate([
        Component({
            name: 'SelectRoleModal'
        })
    ], SelectRoleModal);
    return SelectRoleModal;
}(AbpBase));
export default SelectRoleModal;
;
